import TypeMate from 'typemate';

// Load the parent 
const parent = document.querySelector('.js-typemate__parent');

// Initialise the typemate module 
const typeMateInstance = new TypeMate(parent, { selector: 'h2, p' });

// Run the initial apply
typeMateInstance.apply();

document.getElementById('typemate_switch').addEventListener('change', evt => {
	
	// Apply if enabled
	if(evt.target.checked) {
		typeMateInstance.apply();
	}
	
	// Reset if not
	else {
		typeMateInstance.reset();
	}
});


// WEBPACK FOOTER //
// in/app.js